/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useEffect, useRef, useState } from 'react'
import { useGLTF, useAnimations, Float } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { animated } from "@react-spring/three";

export function BaloonJourneyModel({rotation, bPosition, percent = 0, animate}) {
  const group = useRef()
  const action = useRef()
  const { nodes, animations } = useGLTF('/data/baloon-one-anim.glb')
  const { actions, mixer } = useAnimations(animations, group)

  // mixer.addEventListener('finished', () => {
  //   materials['Material.001'].normalScale.x = 0
  //   materials['Material.001'].normalScale.y = -0
  //   action.current.reset()
  //   action.current.play()
  // })

  useEffect(() => {
      action.current = mixer.clipAction(animations[0]);
      action.current.setEffectiveTimeScale(2)
      action.current.repetitions = 1
      action.current.time = 3.2
      action.current.play();
  }, [mixer, animate]);

  useEffect(() => {
    if(action.current) {
      action.current.reset()
      action.current.time = 3.2
      action.current.play();
    }
  }, [percent])

  useFrame(() => {
    if(action?.current?.time >= 3.2) action.current.paused = true
  })

  return (
    <Float
      speed={1} // Animation speed, defaults to 1
      rotationIntensity={1.4} // XYZ rotation intensity, defaults to 1
      floatIntensity={1} // Up/down float intensity, works like a multiplier with floatingRange,defaults to 1
      floatingRange={[-0.2, 0.2]} >
      <animated.group ref={group} dispose={null} position={bPosition} rotation={rotation}>
        <group name="Scene">
          <mesh
            name="Plane009"
            castShadow
            receiveShadow
            geometry={nodes.Plane009.geometry}
            frustumCulled={false}
            morphTargetDictionary={nodes.Plane009.morphTargetDictionary}
            morphTargetInfluences={nodes.Plane009.morphTargetInfluences}
            scale={0.05}
            >
            <meshPhysicalMaterial color={[
              0.5927983045578003,
              0.30613112449645996,
              0.013865585438907146,
              1
            ]}
            shininess={1}
            specularColor={[
              2.0000000474157864,
              2.0000000474157864,
              2.0000000474157864
            ]}
            specularIntensity={1}
            metalness={1}
            roughness={0.22}/>
          </mesh>
        </group>
      </animated.group>
    </Float>
  )
}

// useGLTF.preload('/data/baloon-one-anim.glb')